import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModule } from './material/material.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { ViewDirective } from './utility/directive/view.directive';
import { CustomMaxDirective } from './utility/directive/custom-max.directive';
import { CustomMinDirective } from './utility/directive/custom-min.directive';
import { MustMatchDirective } from './utility/directive/must-match.directive';
import { DisableDirective } from './utility/directive/disable.directive';
import { NativeElementInjectorDirective } from './utility/directive/nativeElementInjector.directive';

import { AppComponent } from './app.component';
import { Configurations } from '../Configuration';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { SelectDialogComponent } from './utility/dialog/selectDialog/selectDialog.component';
import { UploadStatusDialog } from './utility/service/upload-status.dialog';
import { UploadStatusComponent } from './utility/service/upload/status/status.component';
import { BooleanComponent } from './utility/table/boolean/boolean.component';
import { ButtonComponent } from './utility/table/button/button.component';
import { CheckboxComponent } from './utility/table/checkbox/checkbox.component';
import { CloudComponent } from './utility/table/cloud/cloud.component';
import { FontIconComponent } from './utility/table/icon/icon.component';
import { MenucolumnComponent } from './utility/table/menu-column/menucolumn.component';
import { MenuItemComponent } from './utility/table/menu-item/menu-item.component';
import { MultiColumnComponent } from './utility/table/multi-column/multi-column.component';
import { ProgressComponent } from './utility/table/progress/progress.component';
import { RadioComponent } from './utility/table/radio/radio.component';
import { SeverityComponent } from './utility/table/severity/severity.component';
import { NativeStateComponent } from './utility/table/state/state.component';
import { TextComponent } from './utility/table/text/text.component';
import { ToggleComponent } from './utility/table/toggle/toggle.component';
import { TableComponent } from './utility/table/table.component';
import { WidgetComponent } from './utility/table/widget/widget.component';
import { DynamicComponent } from './utility/table/dynamic/dynamic.component';
import { SanitizehtmlPipe } from './utility/table/sanitizehtml.pipe';
import { UploadService } from './utility/service/upload.service';
import { MessageService } from './utility/service/message.service';
import { SelectTenantDialogComponent } from './utility/dialog/selectTenantDialog/selectTenantDialog.component';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { UserTenantComponent } from './utility/tenant/tenant.component';
import { AuthService } from './utility/auth/auth.service';
import { MenuService } from './utility/auth/menu.service';

export function createTranslateLoader(http: HttpClient) {
  if (SerengetiCommonModule.environment && SerengetiCommonModule.environment.createTranslateLoader) {
    return SerengetiCommonModule.environment.createTranslateLoader(http);
  } else {
    return new MultiTranslateHttpLoader(http, [
      { prefix: 'assets/i18n/common/', suffix: ".json" }
    ]);      
  }
}

export function exportModule() {
  
}

@NgModule({
  declarations: [
    SelectDialogComponent,
    SelectTenantDialogComponent,
    UserTenantComponent,

		UploadStatusDialog,
		UploadStatusComponent,

		TableComponent,

		// Table Cell
    DynamicComponent,
    WidgetComponent,
    
		ViewDirective,
    CustomMinDirective,
    CustomMaxDirective,
    MustMatchDirective,
    DisableDirective,
    NativeElementInjectorDirective,

		SanitizehtmlPipe,
		TextComponent,
		CheckboxComponent,
		RadioComponent,
		ButtonComponent,
		ToggleComponent,
		CloudComponent,
		MultiColumnComponent,
		MenucolumnComponent,
		MenuItemComponent,
		FontIconComponent,
		NativeStateComponent,
		ProgressComponent,
		BooleanComponent,
		SeverityComponent,

    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    DragDropModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    TranslateService,
    MessageService,
    UploadService,
    AuthService,
    MenuService
  ],
  entryComponents: [
		UploadStatusDialog,
		UploadStatusComponent,

		// Table Cell

    DynamicComponent,
    WidgetComponent,
    
		TextComponent,
		CheckboxComponent,
		RadioComponent,
		ButtonComponent,
		ToggleComponent,
		CloudComponent,
		MultiColumnComponent,
		MenucolumnComponent,
		MenuItemComponent,
		FontIconComponent,
		NativeStateComponent,
		ProgressComponent,
		BooleanComponent,
		SeverityComponent,

    SelectDialogComponent,
    SelectTenantDialogComponent
  ],
  exports: [
    SelectDialogComponent,
    SelectTenantDialogComponent,
    UserTenantComponent,
    TableComponent,

    ViewDirective,
    CustomMinDirective,
    CustomMaxDirective,
    MustMatchDirective,
    DisableDirective,
    NativeElementInjectorDirective
  ],
  bootstrap: [ AppComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SerengetiCommonModule {
  public static environment: Configurations = null;

  constructor (translate: TranslateService) {
    translate.setDefaultLang('ko-kr');
    translate.use('ko-kr');
  }

  public static forRoot(environment: Configurations): ModuleWithProviders {
    return {
        ngModule: SerengetiCommonModule,
        providers: [
          { provide: Configurations, useValue: environment }
        ]
    };
  }
}
